import { createFileRoute } from '@tanstack/react-router';
import { ArenaScreen } from '../features/arena/ArenaScreen';
import { RequireAuth } from '../features/auth/RequireAuth';

export const Route = createFileRoute('/arena')({
  component: ArenaRoute,
});

function ArenaRoute(): React.JSX.Element {
  return <RequireAuth role="child">{(me) => <ArenaScreen me={me} />}</RequireAuth>;
}
